var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"149e089bac4f73fcf4e25172483c30fc8f09b08b"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["inbox-ui@capsim"]={id:"149e089bac4f73fcf4e25172483c30fc8f09b08b"};
      